import { Node, findParentNode, mergeAttributes } from '@tiptap/vue-2';
import { TextSelection } from '@tiptap/pm/state';
/** Side-by-side columns (e.g. signatures). Rendered as plain divs so the PDF needs only CSS. */
export const Column = Node.create({
    name: 'column',
    content: 'block+',
    isolating: true,
    parseHTML: () => [{ tag: 'div[data-column]' }],
    renderHTML: ({ HTMLAttributes }) => ['div', mergeAttributes(HTMLAttributes, { 'data-column': '' }), 0],
});
export const Columns = Node.create({
    name: 'columns',
    group: 'block',
    content: 'column{2,}',
    isolating: true,
    parseHTML: () => [{ tag: 'div[data-columns]' }],
    renderHTML: ({ HTMLAttributes }) => ['div', mergeAttributes(HTMLAttributes, { 'data-columns': '' }), 0],
    addCommands() {
        return {
            splitColumn: () => ({ state, tr, dispatch }) => {
                const { schema, selection } = state;
                const emptyColumn = schema.nodes.column.createAndFill();
                const column = findParentNode(n => n.type.name === 'column')(selection);
                if (column) {
                    if (dispatch)
                        tr.insert(column.pos + column.node.nodeSize, emptyColumn);
                    return true;
                }
                if (selection.$from.depth === 0)
                    return false;
                const block = selection.$from.node(1);
                const columns = schema.nodes.columns.create(null, [schema.nodes.column.create(null, block), emptyColumn]);
                if (dispatch)
                    tr.replaceWith(selection.$from.before(1), selection.$from.after(1), columns);
                return true;
            },
            mergeColumn: () => ({ state, tr, dispatch }) => {
                const { schema, selection } = state;
                const column = findParentNode(n => n.type.name === 'column')(selection);
                const columns = findParentNode(n => n.type.name === 'columns')(selection);
                if (!column || !columns)
                    return false;
                const kids = [];
                columns.node.forEach(child => kids.push(child));
                const index = kids.findIndex((_, i) => columns.start + childOffset(columns.node, i) === column.pos);
                const lo = index > 0 ? index - 1 : index;
                const merged = schema.nodes.column.create(null, kids[lo].content.append(kids[lo + 1].content));
                kids.splice(lo, 2, merged);
                if (dispatch) {
                    const from = columns.pos;
                    const to = columns.pos + columns.node.nodeSize;
                    tr.replaceWith(from, to, kids.length === 1 ? kids[0].content : schema.nodes.columns.create(null, kids));
                    tr.setSelection(TextSelection.near(tr.doc.resolve(from + 1)));
                }
                return true;
            },
        };
    },
});
function childOffset(parent, index) {
    let offset = 0;
    for (let i = 0; i < index; i++)
        offset += parent.child(i).nodeSize;
    return offset;
}
